export const GET_TEACHER = "teacher/GET_TEACHER";
